import { WorkspaceMemberRoleValue } from "#src/config/filter/workspace/value";
import type { IWorkspaceItem } from "#src/services/workspace";
import {
  memberActions,
  adminActions,
  ownerActions,
  PermissionAction,
} from "./actions";

enum PermissionRole {
  WORKSPACE_OWNER = "WORKSPACE_OWNER",
  WORKSPACE_ADMIN = "WORKSPACE_ADMIN",
  WORKSPACE_MEMBER = "WORKSPACE_MEMBER",
  GUEST = "GUEST",
}

/** Which role should have which group of actions. For example admin can have both memberActions & adminActions. */
const permissionMatrix: {
  [Role in PermissionRole]: PermissionAction[];
} = {
  [PermissionRole.WORKSPACE_OWNER]: [
    ...memberActions,
    ...adminActions,
    ...ownerActions,
  ],
  [PermissionRole.WORKSPACE_ADMIN]: [...memberActions, ...adminActions],
  [PermissionRole.WORKSPACE_MEMBER]: memberActions,
  [PermissionRole.GUEST]: [],
};

export const getPermissionFromWorkspace = (
  currentWorkspace: IWorkspaceItem | undefined
) => {
  if (!currentWorkspace) return PermissionRole.GUEST;

  if (currentWorkspace.role === WorkspaceMemberRoleValue.OWNER)
    return PermissionRole.WORKSPACE_OWNER;

  if (currentWorkspace.role === WorkspaceMemberRoleValue.ADMIN)
    return PermissionRole.WORKSPACE_ADMIN;

  if (currentWorkspace.role === WorkspaceMemberRoleValue.MEMBER)
    return PermissionRole.WORKSPACE_MEMBER;

  return PermissionRole.GUEST;
};

export const isAllowedTo = (
  action: PermissionAction,
  asRole: PermissionRole
) => {
  // If role have enough permission -> allow
  return permissionMatrix[asRole].includes(action);
};
